import React from "react";

// Contract sheet with a folded corner and signature lines. Same 12x14 box and
// plain-white fill as the other hero-banner stat icons (Height, Weight,
// Birthday, Foot) so the row stays visually uniform.
const Contract = () => {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="white">
        {/* sheet with folded top-right corner */}
        <path d="M2 0.5 H7.5 L10.5 3.5 V13 A0.5 0.5 0 0 1 10 13.5 H2 A0.5 0.5 0 0 1 1.5 13 V1 A0.5 0.5 0 0 1 2 0.5 Z M7.5 1.9 V3.5 H9.1 Z" />
      </g>
      <g stroke="#1A212F" strokeWidth="0.9" strokeLinecap="round">
        {/* text lines */}
        <line x1="3.2" y1="6" x2="8.8" y2="6" />
        <line x1="3.2" y1="8" x2="8.8" y2="8" />
        {/* signature line */}
        <line x1="3.2" y1="11" x2="6.4" y2="11" />
      </g>
    </svg>
  );
};

export default Contract;
